var map = {
	"./en.png": "70ff",
	"./es.png": "b8cf",
	"./logo.png": "cf05",
	"./nv.png": "521a",
	"./pdf.png": "9f06",
	"./stopTalking.png": "0e69",
	"./talkButton.png": "4ce5",
	"./talkButtonActive.webp": "6770",
	"./vi.png": "5207"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";